import { getFullAPIFileURL } from '../../../common/getFullAPIFileURL';
import { CatalogItem, CatalogMergeOption, CatalogSuggestion } from '../../../../redux/api/fymAPI.types';
import { catalogArtworkSrc } from '../catalogArtwork';
import { ClaimWay } from './useClaimRoute';

/** The cover of a matched row: the API sends a file of ours as a relative `files/…` URL. */
export function matchArtworkSrc(url: string | null): string | undefined {
  if (url === null) {
    return undefined;
  }
  return url.startsWith('files/') ? getFullAPIFileURL(url) : url;
}

/** The way the dialog starts on: a suggestion with a match starts on the merge (design c3). */
export function defaultClaimWay(suggestion: CatalogSuggestion | undefined): ClaimWay {
  return suggestion?.matchesCatalogItem === null || suggestion?.matchesCatalogItem === undefined ? 'new' : 'merge';
}

/**
 * Every row of the catalog as a row of the merge picker (design catalog-merge c2, the a2 picker).
 * The matched row is the "Looks like the same song" row.
 */
export function claimMergeOptions(items: CatalogItem[], matchedUuid: string | undefined): CatalogMergeOption[] {
  return items.map((item) => ({
    uuid: item.uuid,
    kind: item.kind,
    title: item.title,
    artistName: item.artistName,
    releaseType: item.releaseType,
    releaseDate: item.releaseDate,
    artworkUrl: catalogArtworkSrc(item, 48) ?? null,
    likelyDuplicate: item.uuid === matchedUuid,
    keepUuid: item.uuid,
  }));
}
